module.exports = __webpack_public_path__ + "static/media/un.e6aabbd5.svg";